import * as React from "react";
import { Tabs, Alert, Divider, Row, Col } from 'antd';

import { ZuluIcon } from 'src/app/shared/icon';
import { GeneralManuallyView } from './general-manually.view';
import { AccommodationManuallyView } from './accommodation-manually.view';
import { CarRentManuallyView } from './car-rent-manually.view';
import { TransferManuallyView } from './transfer-manually.view';
import { FlightManuallyView } from './flight-manually.view';
import { SalesAdjustmentManuallyView } from './sales-adjustment-manually.view';

const TabPane = Tabs.TabPane;

interface Props {
	productManually: ProductManually;
	paxes: PersonOccupancy[];
	currencyCode: string;
	quote: QuoteItem;
	entries: QuoteEntryItem[];
	setBusy: (setBusy: boolean) => void;
	handleTabsAddProduct: (key: string) => void;
}

export class BuildProductView extends React.Component<Props, {}> {
	public render(): React.ReactNode {
		const { currencyCode, entries, handleTabsAddProduct, paxes, productManually, quote, setBusy, children } = this.props;

		const alert = (
			<Alert
				type="info"
				showIcon={true}
				message="Select a product type to build"
				style={{ position: "absolute", left: 230, top: 0 }}
			/>
		);

		return (
			<Row>
				<Col xs={24}>
					<Tabs
						onChange={handleTabsAddProduct}
						activeKey={productManually ? productManually.productType.toString() : undefined}
						tabPosition="left"
					>
						<TabPane tab={<span><ZuluIcon type="icon-hotel" />Accommodation</span>} key="1">
							<AccommodationManuallyView
								model={productManually}
								paxes={paxes}
								setBusy={setBusy}
								currency={currencyCode}
							/>
						</TabPane>
						<TabPane tab={<span><ZuluIcon type="car" />Car Rent</span>} key="2">
							<CarRentManuallyView
								model={productManually}
								paxes={paxes}
								setBusy={setBusy}
								currency={currencyCode}
							/>
						</TabPane>
						<TabPane tab={<span><ZuluIcon type="icon-train" />Transfer</span>} key="3">
							<TransferManuallyView
								model={productManually}
								paxes={paxes}
								setBusy={setBusy}
								currency={currencyCode}
							/>
						</TabPane>
						<TabPane tab={<span><ZuluIcon type="icon-plane" />Flight</span>} key="4">
							<FlightManuallyView
								model={productManually}
								paxes={paxes}
								setBusy={setBusy}
								currency={currencyCode}
							/>
						</TabPane>
						<TabPane tab={<span><ZuluIcon type="tags" />General</span>} key="0">
							<GeneralManuallyView
								model={productManually}
								paxes={paxes}
								setBusy={setBusy}
								currency={currencyCode}
							/>
						</TabPane>
						<TabPane tab={<span><ZuluIcon type="wallet" />Sell Price Adjustment</span>} key="7">
							<SalesAdjustmentManuallyView
								model={productManually}
								paxes={paxes}
								setBusy={setBusy}
								quote={quote}
								entries={entries}
								currencyCode={currencyCode}
							/>
						</TabPane>
					</Tabs>
					{(productManually == null || productManually.productType < 0) && alert}
					<Divider />
					{children}
				</Col>
			</Row>
		);
	}
}



// WEBPACK FOOTER //
// ./src/app/bookings/product-manually/build-product.view.tsx